document.addEventListener('DOMContentLoaded', () => {
    document.getElementById('LoginFormSubmit')?.addEventListener('click', function (e) {

        const email = document.querySelector('#LoginForm input[name="customer[email]"]')?.value.trim();
        const password = document.querySelector('#LoginForm input[name="customer[password]"]')?.value.trim();

        const messageEmail = document.querySelector('#LoginForm #error-email');
        const messagePassword = document.querySelector('#LoginForm #error-password');

        console.log(messageEmail);

        let hasError = false;

        const showError = (element, message,inputElement) => {
            element.classList.remove('hidden');
            element.innerText = message;
            inputElement.classList.add('has-error');
            hasError = true;
        };

        const hideError = (element,inputElement) => {
            element.classList.add('hidden');
            inputElement.classList.remove('has-error');
            element.innerText = '';
        };

        // Validate email
        const emailInput = document.querySelector('#LoginForm input[name="customer[email]"]');
        if (!email) {
            showError(messageEmail, 'This is a required field.',emailInput);
        } else if (!/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(email)) {
            showError(messageEmail, 'Please enter a valid email address.',emailInput);
        } else {
            hideError(messageEmail,emailInput);
        }

        // Validate password
        const passwordInput = document.querySelector('#LoginForm input[name="customer[password]"]');

        if (!password) {
            showError(messagePassword, 'This is a required field.', passwordInput);

        } else {
            hideError(messagePassword,passwordInput);
        }

        if (hasError) e.preventDefault();
    });
        document.getElementById('RecoverPasswordForm')?.addEventListener('click', function (e) {
            const recoverEmail = document.querySelector('#RecoverForm input[name="email"]')?.value.trim();
            const messageEmail = document.querySelector('#error-recover-email');

            let hasError = false;
            const showError = (element, message, inputElement) => {
                element.classList.remove('hidden');
                element.innerText = message;
                inputElement.classList.add('has-error');
                hasError = true;
            };

            const hideError = (element, inputElement) => {
                element.classList.add('hidden');
                element.innerText = '';
                inputElement.classList.remove('has-error');
            };
            // Validate recover email
            const recoverEmailInput = document.querySelector('#RecoverForm input[name="email"]');
            if (!recoverEmail) {
                showError(messageEmail, 'This is a required field.', recoverEmailInput);
                hasError = true;
            } else if (!/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(recoverEmail)) {
                showError(messageEmail, 'Please enter a valid email address.', recoverEmailInput);
                hasError = true;
            } else {
                hideError(messageEmail, recoverEmailInput);
            }

            if (hasError) e.preventDefault();
        });
  })